import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const OrderListStyle = StyleSheet.create({
    savebutton:
    {
        backgroundColor: appColors?.primary,
        borderRadius: 10,
        paddingHorizontal: 20,
    },
    cancelButton:
    {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        paddingVertical: 2,
        paddingHorizontal: 20,
        borderWidth: 0.5,
        borderColor: appColors?.primary
    },
    container: {
        backgroundColor: appColors.light,
        flex: 1,
        marginTop: 10,
        paddingHorizontal: 12,
        paddingVertical: 12,
        borderRadius: 10,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap'
    },
    rowTop: {
        justifyContent: 'flex-start',
    },
    checkboxContainer: {
        width: 40,
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    orderBlock: {
        flex: 1.2,
        paddingLeft: 6,
        justifyContent: 'center'
    },
    orderIdText: {
        fontSize: fontSize?.smallFontSize,
        fontFamily: appFonts.bold,
    },
    customerBlock: {
        flex: 1.6,
        paddingLeft: 6,
        justifyContent: 'center'
    },
    inlineRow: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    customerText: {
        marginLeft: 6
    },
    badgeAndStatusBlock: {
        flex: 1.4,
        paddingLeft: 6,
        justifyContent: 'center'
    },
    badgeRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginBottom: 6
    },
    badgeMargin: {
        marginRight: 6
    },
    statusWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12
    },
    statusRow: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    amountBlock: {
        width: 120,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    actionBlock: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 10
    },
    iconBox: {
        padding: 10,
        backgroundColor: appColors.lightBackgroundColor,
        borderRadius: 10,
        marginLeft: 10
    },


    /* Mobile specific rows */
    mobileBadgesRow: {
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    mobileBottomRow: {
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    amountBlockMobile: {
        flex: 1,
        justifyContent: 'center'
    },
    actionBlockMobile: {
        flexDirection: 'row',
        alignItems: 'center'
    },

    deleteIconView2: {
        alignSelf: "flex-end",
        backgroundColor: appColors.red,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    cardContainer: {
        backgroundColor: appColors.light,
        padding: 10,
        borderRadius: 16,
        marginBottom: 10,
        marginHorizontal: 10,
        borderWidth: 1,
        borderColor: '#F1F5F9',
        // Shadow for iOS
        shadowColor: '#0F172A',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        // Elevation for Android
        elevation: 2,
    },

    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    headerLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    storeIconContainer: {
        width: 40,
        height: 40,
        borderRadius: 8,
        backgroundColor: appColors.lightPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 8,
    },
    headerTexts: {
        marginLeft: 12,
        flex: 1,
    },
    headerOrderId: {
        fontFamily: appFonts.bold,
        color: appColors.lightDark,
    },
    headerDate: {
        marginTop: 2,
        color: appColors.grey,
    },
    headerRightActions: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
    },
    actionCircleButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: appColors.lightBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionDeleteCircleButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#FEF2F2',
        justifyContent: 'center',
        alignItems: 'center',
    },
    badgesRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: 12,
        gap: 8,
    },
    customBadge: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingVertical: 5,
        borderRadius: 20,
    },
    customBadgeDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        marginRight: 6,
    },
    cardDivider: {
        marginVertical: 10,
        backgroundColor: '#F1F5F9',
        height: 1,
    },
    gridContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    gridItem: {
        flexDirection: 'row',
        alignItems: 'center',
        // marginBottom: 10,
        paddingRight: 5,
    },
    gridItemIconContainer: {
        width: 30,
        height: 30,
        borderRadius: 18,
        backgroundColor: '#EFF6FF',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 10,
    },
    gridItemTextContainer: {
        flex: 1,
        flexDirection: "row",
        // gap: 10
    },
    iconButton: {
        width: 40,
        height: 40,
        borderRadius: 10,
        borderWidth: 0.8,
        borderColor: appColors.grey,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: appColors.light,
    },
    searchRowContainer: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 10,
        marginTop: 10,
        gap: 10,
    },
    searchBarContainer: {
        flex: 1,
        backgroundColor: appColors.light,
        borderRadius: 20,
        height: 45,
        paddingHorizontal: 10,
        justifyContent: "center",
    },
    searchInput: {
        color: appColors.lightDark,
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium,
        paddingLeft: 10,
    },
    locationBox: {
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        borderColor: appColors.lightGrey,
        borderRadius: 10,
        height: 40,
        paddingHorizontal: 10,
        backgroundColor: appColors.light,
    },
});


